export const TAB_WIDTH = 100;
export const SCROLL_OFFSET = 3;
export const DUPLICATE_TABS_BY = 9;
